import React, { useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { renderIcon, kuiperClassNames } from '@opallabs/kuiper'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import { sharedColors, sharedStyles } from '../../sharedStyles'
import { styles } from './styles'

const getSecondAccountProps = (collabAccount: string) => ({
  name: collabAccount || 'No collab account',
  color: collabAccount ? 'black' : `${sharedColors.emptyCollab}`,
  style: collabAccount ? styles.collabAccountName : styles.emptyCollabStyles,
})
export interface Props {
  accountImage: AssetReference | null
  accountUsername: string
  collabAccount: string
  instagramCollab: boolean
  location: string
  musicTitle: string
  onMusicChange: (val: string) => void
  postType: string
  readOnly: boolean
}

export const MobileStreamHeader: React.FC<Props> = ({
  accountImage,
  accountUsername,
  collabAccount,
  instagramCollab,
  location,
  musicTitle,
  onMusicChange,
  postType,
  readOnly,
}) => {
  const [isMusicHovered, setIsMusicHovered] = useState(false)
  const [musicValue, setMusicValue] = useState(musicTitle)

  const handleMusicChange = () => {
    onMusicChange(musicValue)
  }

  return (
    <div
      css={styles.header}
      className={kuiperClassNames('instagram-mobile-header')}
    >
      <div
        css={styles.avatarUsername}
        className={kuiperClassNames('instagram-avatar-username')}
      >
        {instagramCollab ? (
          <React.Fragment>
            <div css={sharedStyles.collabAvatarStyles}>
              <ContentAvatar
                assetReference={accountImage}
                style={styles.avatar}
                size={24}
              />
              <ContentAvatar
                assetReference={null}
                style={sharedStyles.secondAvatarStyles}
                size={24}
              />
            </div>
            <div css={styles.collabAccountWrapper(collabAccount)}>
              <AccountName
                style={styles.collabAccountName}
                color={`${sharedColors.darkGreyText}`}
                name={accountUsername}
              />
              <span css={styles.collabSpan}> and </span>
              <AccountName {...getSecondAccountProps(collabAccount)} />
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <ContentAvatar
              assetReference={accountImage}
              style={styles.avatar}
            />
            <AccountName
              color={`${sharedColors.darkGreyText}`}
              name={accountUsername}
              style={styles.account(
                !!location || postType === 'reel',
                'mobileStream'
              )}
            />
          </React.Fragment>
        )}
        {postType === 'reel' && (
          <div
            css={styles.musicContainer}
            className={kuiperClassNames('instagram-music')}
            onBlur={handleMusicChange}
            onMouseEnter={() => setIsMusicHovered(true)}
            onMouseLeave={() => setIsMusicHovered(false)}
          >
            <input
              aria-label="Content Music Text"
              css={styles.music(isMusicHovered, readOnly)}
              readOnly={readOnly}
              value={musicValue}
              placeholder={'Add music...'}
              onChange={(e) => setMusicValue(e.target.value)}
            />
          </div>
        )}
        {Boolean(location) && postType !== 'reel' && (
          <span
            css={styles.location}
            className={kuiperClassNames('instagram-location')}
          >
            {location}
          </span>
        )}
      </div>
      {renderIcon('instagram-mobile-more', {
        style: { width: 13 },
        ariaMode: 'hidden',
      })}
    </div>
  )
}
